module.exports = __webpack_public_path__ + "assets/media/phone-desktop.27de60da.jpg";